import { render, staticRenderFns } from "./CallView.vue?vue&type=template&id=7567d24e&scoped=true&"
import script from "./CallView.vue?vue&type=script&lang=js&"
export * from "./CallView.vue?vue&type=script&lang=js&"
import style0 from "./CallView.vue?vue&type=style&index=0&id=7567d24e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567d24e",
  null
  
)

export default component.exports